import axios from "axios";
import { API_R3API_ODOO_EXECUTE_URI } from "../Context/Constants";
import { getAuthRequestContext } from "./authRequest";
import {
  parseSubscriptionValidityResponse,
  STATUS_ERROR
} from "./subscriptionValidityUtils";

export const fetchSubscriptionValidity = async (email, headers) => {
  const resp = await axios.post(
    API_R3API_ODOO_EXECUTE_URI,
    {
      action: "subscriptionvaliditycheck",
      domain: process.env.REACT_APP_DOMAIN_PARAM,
      emailid: email,
      company: false,
      companyname: "",
      region: ""
    },
    { headers }
  );

  return parseSubscriptionValidityResponse(resp.data);
};

export const fetchSubscriptionValidityForCurrentUser = async () => {
  try {
    const { email, headers } = await getAuthRequestContext();
    return await fetchSubscriptionValidity(email, headers);
  } catch (error) {
    console.error("fetchSubscriptionValidity failed:", error.message);
    return {
      status: STATUS_ERROR,
      expirationDate: null,
      expirationDateRaw: null,
      message: error.message || "Unable to verify your subscription status. Please try again."
    };
  }
};
